/* eslint-disable @typescript-eslint/no-explicit-any */

import { mulberry32 } from '../hash/hash';

function pathValue<T extends { [key: string]: any }>(obj: T, path: string) {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

export function ArrayUniqueObjects<T extends { [key: string]: any }>(
  arr: Array<T>,
  keys: Array<string>,
  matchAllKeys = true,
): Array<T> {
  const unique: Array<T> = [];

  arr.forEach((item) => {
    const hasItem = unique.some((obj) => {
      const identicalKeys = keys.filter((key) => {
        const objValue = pathValue(obj, key);
        const itemValue = pathValue(item, key);

        return objValue === itemValue;
      });

      return matchAllKeys
        ? keys.length === identicalKeys.length
        : identicalKeys.length > 0;
    });

    if (!hasItem) {
      unique.push(item);
    }
  });

  return unique;
}

// Perform Fisher-Yates Shuffle using the seeded Mulberry32 PRNG
export function seededShuffle(array: Array<any>, seed: number): Array<any> {
  const shuffled = [...array];
  const mulberryRandom = mulberry32(seed);

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(mulberryRandom() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
}
